var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCircleBlue2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#0a5ec0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.322 23h-10.48v-2.205l3.763-3.804q1.672-1.711 2.185-2.368.512-.668.738-1.23a3.1 3.1 0 0 0 .225-1.17q0-.903-.502-1.343-.493-.441-1.323-.441-.87 0-1.692.4-.82.4-1.712 1.138L10.8 9.937q1.108-.945 1.836-1.333a6.6 6.6 0 0 1 1.59-.595 8 8 0 0 1 1.927-.216q1.405 0 2.481.513 1.077.512 1.672 1.436.594.923.594 2.112 0 1.035-.369 1.948-.358.902-1.128 1.856-.759.954-2.686 2.717L14.79 20.19v.144h6.532z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleBlue2);
export default __webpack_public_path__ + "static/media/icon-circle-blue-2.cb34d3a205d2330f0501992b0cc352be.svg";
export { ForwardRef as ReactComponent };